// full updated code (starts here)
import React, { useState, useEffect } from "react";
import classes from './Prchasing.module.css';
import HeaderNav from '../../Components/Dahboard Header/HeaderNav/HeaderNav';
import Footer from "../../Components/Footer/Footer";
import { Trash2, Upload } from "lucide-react";
import api, { withCompanyId } from "../../Components/API/Api";
import { Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import { useLocation, useNavigate } from "react-router-dom";
import Select from "react-select";
import { useUser } from "../../UserContext";


const Prchasing = () => {
  const { user } = useUser();
  const userRole = (user?.role || user?.user_type || user?.account_type || user?.type || '').toLowerCase();
  const isSuperAdmin = userRole === 'super admin' || userRole === 'superadmin' || userRole === 'super_admin';
  const location = useLocation();
  // const [invoiceItems, setInvoiceItems] = useState([]);
  const [currency, setCurrency] = useState("");
  const [reference, setReference] = useState("");
  const [currencies, setCurrencies] = useState([]);
  const [services, setServices] = useState([]);
  const [orderToSearch, setOrderToSearch] = useState("");
  const [showOrderTo, setShowOrderTo] = useState(false);
  // Currency dropdown states
  const [currencyOptions, setCurrencyOptions] = useState([]);
  const [selectedCurrency, setSelectedCurrency] = useState("");
  const [currencySearch, setCurrencySearch] = useState("");
  const [showCurrency, setShowCurrency] = useState(false);

  const navigate = useNavigate();
  const [vatRates, setVatRates] = useState([]);
  const [products, setProducts] = useState([]);
  const [isSaving, setIsSaving] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [selectedCustomerId, setSelectedCustomerId] = useState("");
  const [type, setType] = useState("products");
  const [transactionDate, setTransactionDate] = useState("");
  const [dueDate, setDueDate] = useState("");
  const [selectedType, setSelectedType] = useState("");
  const [stores, setStores] = useState([]);
  const [loadingStores, setLoadingStores] = useState(false);
  const [selectedStoreId, setSelectedStoreId] = useState("");

  const [selectedCustomerName, setSelectedCustomerName] = useState("");
  const [selectedCurrencyText, setSelectedCurrencyText] = useState("");
  const formatNumberInput = (value) => {
    const raw = value.replace(/,/g, ''); // remove commas
    if (!raw) return '';
    const number = parseFloat(raw);
    if (isNaN(number)) return '';
    return number.toLocaleString();
  };
  const cleanNumber = (value) => {
    const num = parseFloat(String(value).replace(/,/g, ''));
    return isNaN(num) ? "0.00" : num.toFixed(2); // string output
  };



  const [items, setItems] = useState([
    {
      ledger: "",
      qty: 1,
      price: 0,
      discount: 0,
      vat: 0,
      description: "",
      total: 0
    }
  ]);


  const [invoiceItems, setInvoiceItems] = useState([
    {
      type: "product",
      ledger: '',
      description: '',
      qty: 1,
      price: 0,
      discount: 0,
      vatRate: 'Premium',
      vat: 0,
      total: 0
    }
  ]);

  const pageMap = {
    '/dashboard': 'Dashboard',
    '/transactions': 'Transactions',
    '/accounts': 'Accounting',
    '/reports': 'Reports',
    '/banking': 'Banking',
    '/settings': 'Settings',
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await api.get(`/v1/customer`);
        const customerData = res.data?.data?.data || res.data?.data || [];
        setCustomers(customerData);
      } catch (err) {
        console.error("Error fetching customers:", err);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [servicesRes, productsRes] = await Promise.all([
          api.get(`/v1/items/fetch-services`),
          api.get(`/v1/items/fetch-products`),
        ]);
        if (servicesRes?.data?.status) setServices(servicesRes.data.data);
        if (productsRes?.data?.status) setProducts(productsRes.data.data);
      } catch (error) {
        console.error("Error fetching services/products:", error);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [refRes, currencyRes] = await Promise.all([
          api.get(`/v1/generate-sales-invoice-code`),
          api.get(`/v1/fetch-all-currencies`),
        ]);
        if (refRes?.data?.data) setReference(refRes.data.data.toString());
        if (currencyRes?.data?.data) setCurrencies(currencyRes.data.data);
      } catch (error) {
        console.error("Error fetching initial data:", error);
      }
    };
    fetchData();
  }, []);
  
  // Fetch stores list for Super Admins
  useEffect(() => {
    const fetchData = async () => {
      if (!isSuperAdmin) return;
      setLoadingStores(true);
      try {
        const res = await api.get(`/v1/store`);
        let storesData = res.data?.data?.data || res.data?.data || res.data;
        if (!Array.isArray(storesData)) storesData = [];
        const normalized = storesData.map(s => ({ id: s.id ?? s.store_id ?? s.value, name: s.name ?? s.store_name ?? s.title ?? `Store ${s.id ?? s.store_id}` }));
        setStores(normalized);
      } catch (err) {
        console.error("Error fetching stores:", err);
        setStores([]);
      } finally {
        setLoadingStores(false);
      }
    };
    fetchData();
  }, [isSuperAdmin]);

  // When a store is selected by Super Admin, fetch products for that store, clear mismatched rows
  useEffect(() => {
    const fetchData = async () => {
      if (!isSuperAdmin) return;
      if (!selectedStoreId) {
        setStocks([]);
        setInvoiceItems(prev => prev.map(row => ({
          ...row,
          ledger: '',
          price: 0,
          qty: 1,
          discount: 0,
          vat: 0,
          total: 0,
          search: '',
          dropdownOpen: false
        })));
        return;
      }
      try {
        const res = await api.get(`/v1/get_store_products`, {
          params: { store_id: Number(selectedStoreId) }
        });
        const raw = res.data?.data?.data || res.data?.data || res.data;
        const list = Array.isArray(raw) ? raw : [];
        const normalized = list.map(p => ({
          id: p?.id,
          name: p?.name || p?.product_name || p?.stock_name || p?.title || `Product ${p?.id || ''}`,
          price: p?.price || p?.unit_price || p?.selling_price || p?.cost_price || 0,
          description: p?.description || ''
        }));
        setStocks(normalized);
        const allowedIds = new Set(normalized.map(p => p.id));
        const allowedNames = new Set(normalized.map(p => p.name));
        setInvoiceItems(prev => prev.map(row => {
          const hasNameMismatch = row.ledger && !allowedNames.has(row.ledger);
          if (hasNameMismatch) {
            return {
              ...row,
              ledger: '',
              price: 0,
              qty: 1,
              discount: 0,
              vat: 0,
              total: 0,
              search: '',
              dropdownOpen: false
            };
          }
          return row;
        }));
      } catch (err) {
        console.error("Error fetching products for store:", err);
        setStocks([]);
        setInvoiceItems(prev => prev.map(row => ({
          ...row,
          ledger: '',
          price: 0,
          qty: 1,
          discount: 0,
          vat: 0,
          total: 0,
          search: '',
          dropdownOpen: false
        })));
      }
    };
    fetchData();
  }, [isSuperAdmin, selectedStoreId]);
  const handleProductSelect = (rowIndex, productName) => {
    setItems(prevItems => {
      const updatedItems = [...prevItems];
      const selectedProduct = stocks.find(p => p.name === productName);

      updatedItems[rowIndex].ledger = productName;
      if (selectedProduct) {
        // ✅ Use price
        updatedItems[rowIndex].price = selectedProduct.price;
      }
      return updatedItems;
    });
  };





  const handleAddRow = () => {
    setInvoiceItems(prev => [
      ...prev,
      {
        type: type === "products" ? "product" : "service",
        ledger: '',
        description: '',
        qty: 1,
        price: 0,
        discount: 0,
        vatRate: 'Premium',
        vat: 0,
        total: 0
      }
    ]);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await api.get(`/v1/taxes/company-tax`);
        if (res?.data?.status && Array.isArray(res.data.data)) {
          setVatRates(res.data.data);
        }
      } catch (error) {
        console.error("Failed to fetch VAT rates:", error);
      }
    };
    fetchData();
  }, []);

  const handleDeleteRow = (index) => {
    const updated = [...invoiceItems];
    updated.splice(index, 1);
    setInvoiceItems(updated);
  };
  const handleChange = (index, field, value) => {
    setInvoiceItems(prev => {
      const updated = [...prev];
      updated[index][field] = value;

      if (field === 'ledger') {
        const selectedItem = Array.isArray(stocks) ? stocks.find(item => item.name === value) : undefined;
        if (selectedItem) {
          updated[index].price = parseFloat(selectedItem.price || selectedItem.cost_price || 0);
          updated[index].qty = 1;
          updated[index].discount = 0;
        } else {
          // Reset when item not valid in current store
          updated[index].price = 0;
          updated[index].qty = 1;
          updated[index].discount = 0;
        }
      }

      // ✅ VAT toggle
      if (field === 'vatChecked') {
        updated[index].tax_id = value ? 1 : null;
      }

      // ✅ WHT toggle
      if (field === 'wthChecked') {
        updated[index].wht_id = value ? 2 : null;
      }

      const qty = parseFloat(updated[index].qty) || 0;
      const price = parseFloat(updated[index].price) || 0;
      const lineTotal = qty * price;

      let discount = parseFloat(updated[index].discount) || 0;
      let discountRate = parseFloat(updated[index].discountRate) || 0;

      // ✅ If user updates percentage → recalc amount
      if (field === "discountRate") {
        discount = (discountRate / 100) * lineTotal;
        updated[index].discount = discount;
      }

      // ✅ If user updates amount → recalc percentage
      if (field === "discount") {
        discountRate = lineTotal > 0 ? (discount / lineTotal) * 100 : 0;
        updated[index].discountRate = discountRate;
      }

      const taxable = lineTotal - discount;

      updated[index].vat = updated[index].tax_id === 1 ? 0.075 * taxable : 0;
      updated[index].wht = updated[index].wht_id === 2 ? 0.02 * taxable : 0;

      updated[index].total = taxable + updated[index].vat - updated[index].wht;

      return updated;
    });
  };



  const totalDiscount = invoiceItems.reduce((sum, item) => sum + (item.discount || 0), 0);
  const totalVat = invoiceItems.reduce((sum, item) => sum + (item.vat || 0), 0);
  const totalWht = invoiceItems.reduce((sum, item) => sum + (item.wht || 0), 0);  // ✅ new
  const totalAmount = invoiceItems.reduce((sum, item) => sum + (item.total || 0), 0);
  const totalQty = invoiceItems.reduce((sum, item) => sum + (Number(item.qty) || 0), 0);








  const subtotal = invoiceItems.reduce((acc, item) => {
    const qty = Number(item.qty) || 0;
    const price = Number(item.price) || 0;
    const discount = Number(item.discount) || 0;
    const lineTotal = (qty * price) - discount;
    return acc + lineTotal;
  }, 0);
  const totalVAT = invoiceItems.reduce((acc, item) => acc + item.vat, 0);
  const grandTotal = invoiceItems.reduce((acc, item) => acc + item.total, 0);


  const handleSaveInvoice = async () => {
    if (
      !selectedOrderTo ||   // supplier (Order To) must be selected
      !transactionDate ||
      !dueDate ||
      !reference ||
      !currency ||
      invoiceItems.length === 0
    ) {
      Swal.fire("Missing Fields", "Please fill all required fields.", "warning");
      return;
    }

    // Find the supplier_id from selectedOrderTo
    const supplier = orderToOptions.find(o => o.name === selectedOrderTo);

    if (!supplier) {
      Swal.fire("Missing Supplier", "Please select a valid supplier.", "warning");
      return;
    }

    const item = [];
    const quantity = [];
    const amount = [];
    const tax_ids = [];  // ✅ new
    const wht_ids = [];  // ✅ new

    invoiceItems.forEach((row, idx) => {
      const selectedStock = stocks.find(s => s.name === row.ledger);

      if (!selectedStock) {
        Swal.fire(
          "Invalid Item",
          `Row ${idx + 1}: Please select a valid stock item.`,
          "warning"
        );
        return;
      }

      const lineTotal = (Number(row.qty) || 0) * (Number(row.price) || 0);

      item.push(selectedStock.id);
      quantity.push(row.qty);
      amount.push(lineTotal);

      tax_ids.push(row.tax_id || null);   // ✅ VAT toggle
      wht_ids.push(row.wht_id || null);   // ✅ WHT toggle
    });

    const sub_total = invoiceItems.reduce(
      (sum, row) => sum + ((Number(row.qty) || 0) * (Number(row.price) || 0)),
      0
    );

    const total_discount = invoiceItems.reduce(
      (sum, row) => sum + (Number(row.discount) || 0),
      0
    );

    const total_vat = invoiceItems.reduce(
      (sum, row) => sum + (Number(row.vat) || 0),
      0
    );

    const total_amount = invoiceItems.reduce(
      (sum, row) => sum + (Number(row.total) || 0),
      0
    );
    const total_price = total_amount; // keep aligned
    // Build array of discount percentages for each item
    const discount_percentages = invoiceItems.map(row => {
      const qty = Number(row.qty) || 0;
      const price = Number(row.price) || 0;
      const lineTotal = qty * price;
      return lineTotal > 0 ? ((row.discount || 0) / lineTotal) * 100 : 0;
    });
    const total_wht = invoiceItems.reduce(
      (sum, row) => sum + (Number(row.wht) || 0),
      0
    );

    const payload = {
      supplier_id: supplier.id,
      transaction_date: transactionDate,
      document_number: reference,
      expiring_date: dueDate,
      currency: currency,
      sub_total: sub_total.toFixed(2),        // 👈 format as string "1234.00"
      total_discount: total_discount.toFixed(2),
      total_vat: total_vat.toFixed(2),
      total_wht: total_wht.toFixed(2),
      total_price: total_price.toFixed(2),
      total_amount: total_amount.toFixed(2),
      item,
      quantity,
      amount,
      discount: invoiceItems.map(i => i.discount || 0),
      discount_percentage: discount_percentages,
      tax_id: tax_ids,
      wht_id: wht_ids,
      ...(isSuperAdmin && selectedStoreId ? { store_id: selectedStoreId } : {})
    };

    setIsSaving(true);
    try {
      await api.post(`/v1/create-purchase-order`, withCompanyId(payload));

      Swal.fire("Success", "Purchase Order created successfully!", "success").then(() => {
        navigate("/inventory/purchaseOrder");   // 👈 redirect instead of reload
      });
    } catch (error) {
      const msg = error?.response?.data?.message || "Submission failed!";
      Swal.fire("Failed", JSON.stringify(msg), "error");
    } finally {
      setIsSaving(false);
    }
  };



  const [orderToOptions, setOrderToOptions] = useState([]);
  const [selectedOrderTo, setSelectedOrderTo] = useState("");

  // Fetch Order To options (Beneficiaries)
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await api.get(`/v1/beneficiary`);
        if (res?.data?.status && Array.isArray(res.data.data)) {
          setOrderToOptions(res.data.data);
        }
      } catch (error) {
        console.error("Error fetching beneficiaries:", error);
      }
    };
    fetchData();
  }, []);
  const [stocks, setStocks] = useState([]);
  useEffect(() => {
    // For Super Admins, stocks should come ONLY after selecting a store
    if (isSuperAdmin) return;

    const fetchData = async () => {
      try {
        const res = await api.get(`/v1/fetch_stocks`);
        if (res?.data?.status) setStocks(res.data.data || []);
      } catch (err) {
        console.error("Error fetching stocks:", err);
      }
    };
    fetchData();
  }, [isSuperAdmin]);

  // state for file
  const [supportingDoc, setSupportingDoc] = useState(null);

  // handler
  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setSupportingDoc(e.target.files[0]);
    }
  };
  const [itemSearch, setItemSearch] = useState("");


  const filteredStocks = stocks.filter(stock =>
    stock.name.toLowerCase().includes(itemSearch.toLowerCase())
  );

  const [showItemDropdown, setShowItemDropdown] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  // remove these global states
  // const [itemSearch, setItemSearch] = useState("");
  // const [dropdownOpen, setDropdownOpen] = useState(false);

  const handleSearchChange = (idx, value) => {
    setInvoiceItems(prev => {
      const updated = [...prev];
      updated[idx].search = value;  // store search text per row
      return updated;
    });
  };

  const toggleDropdown = (idx) => {
    setInvoiceItems(prev => {
      const updated = [...prev];
      updated[idx].dropdownOpen = !updated[idx].dropdownOpen; // toggle per row dropdown
      return updated;
    });
  };

  const handleSelectItem = (idx, stock) => {
    handleChange(idx, "ledger", stock.name); // already updates price from stock
    setInvoiceItems(prev => {
      const updated = [...prev];
      updated[idx].search = stock.name;  // show chosen item in input
      updated[idx].dropdownOpen = false;
      return updated;
    });
  };


  return (
    <div>
      <HeaderNav activePage={pageMap[location.pathname]} />
      <div className={classes.Container}>
        <header className={classes.Header}>
          <h2 className={classes.Title}>Create Purchase Order</h2>
        </header>
        <form className={classes.form}>
          {isSuperAdmin && (
            <div className={classes.group1}>
              <label>Store</label>
              <Select
                isClearable
                isSearchable
                isDisabled={loadingStores}
                placeholder={loadingStores ? 'Loading stores...' : 'Select store'}
                options={stores.map((store) => ({
                  value: String(store.id),
                  label: store.name || `Store ${store.id}`
                }))}
                value={(() => {
                  const options = stores.map((store) => ({
                    value: String(store.id),
                    label: store.name || `Store ${store.id}`
                  }));
                  return options.find(o => o.value === String(selectedStoreId)) || null;
                })()}
                onChange={(option) => setSelectedStoreId(option?.value || "")}
              />
            </div>
          )}

          <div className={classes.group}>
            <label>Order To</label>
            <div
              className={`${classes["select-container"]} ${showOrderTo ? classes.active : ""}`}
            >
              <input
                type="text"
                placeholder="Search Order To..."
                value={orderToSearch || selectedOrderTo}
                onClick={() => {
                  setShowOrderTo((prev) => !prev);
                  if (!showOrderTo) setOrderToSearch("");
                }}
                onChange={(e) => {
                  setOrderToSearch(e.target.value);
                  setShowOrderTo(true);
                }}
                className={classes["select-search"]}
              />
              {showOrderTo && (
                <div className={classes["select-dropdown"]}>
                  {orderToOptions
                    .filter((item) =>
                      orderToSearch
                        ? item.name?.toLowerCase().includes(orderToSearch.toLowerCase())
                        : true
                    )
                    .map((item) => (
                      <div
                        key={item.id}
                        className={classes["select-option"]}
                        onClick={() => {
                          setSelectedOrderTo(item.name);
                          setOrderToSearch(item.name);
                          setShowOrderTo(false);
                        }}
                      >
                        {item.name}
                      </div>
                    ))}
                </div>
              )}
            </div>
          </div>


          <div className={classes.group2}>
            <label>PV Number</label>
            <input type="text" value={reference} readOnly />
          </div>

          <div className={classes.group2}>
            <label>Supporting Doc.</label>

            {/* Hidden file input */}
            <div className={classes.fileUpload}>
              <label htmlFor="supportingDoc" className={classes.fileLabel}>
                {supportingDoc ? supportingDoc.name : "Choose Supporting Document"}
              </label>
              <input
                id="supportingDoc"
                type="file"
                style={{ display: "none" }}
                onChange={handleFileChange}
              />
            </div>



          </div>
          <div className={classes.group1}>
            <label>Transaction Date</label>
            <input
              type="date"
              value={transactionDate}
              onChange={(e) => setTransactionDate(e.target.value)}
              required
            />
          </div>

          <div className={classes.group1}>
            <label>Expiry Date</label>
            <input
              type="date"
              value={dueDate}
              onChange={(e) => setDueDate(e.target.value)}
              required
            />
          </div>

          <div className={classes.group1}>
            <label>Currency</label>
            <div
              className={`${classes["select-container"]} ${showCurrency ? classes.active : ""}`}
            >
              <input
                type="text"
                placeholder="Search Currency..."
                value={currencySearch || selectedCurrencyText}
                onClick={() => {
                  setShowCurrency((prev) => !prev);
                  if (!showCurrency) setCurrencySearch("");
                }}
                onChange={(e) => {
                  setCurrencySearch(e.target.value);
                  setShowCurrency(true);
                }}
                className={classes["select-search"]}
                required
              />
              {showCurrency && (
                <div className={classes["select-dropdown"]}>
                  {currencies
                    .filter((cur) =>
                      currencySearch
                        ? `${cur.symbol} ${cur.code} - ${cur.country}`
                          .toLowerCase()
                          .includes(currencySearch.toLowerCase())
                        : true
                    )
                    .map((cur) => (
                      <div
                        key={cur.id}
                        className={classes["select-option"]}
                        onClick={() => {
                          setCurrency(cur.id);
                          setSelectedCurrencyText(`${cur.symbol} ${cur.code} - ${cur.country}`);
                          setCurrencySearch(`${cur.symbol} ${cur.code} - ${cur.country}`);
                          setShowCurrency(false);
                        }}
                      >
                        {cur.symbol} {cur.code} - {cur.country}
                      </div>
                    ))}
                </div>
              )}
            </div>
          </div>







        </form>
        <div className={classes.invoicecont}>
          <h3 className={classes.tableTitle}>Add Item(s)</h3>

          <table className={classes.invoiceTable}>
            <thead>
              <tr>
                <th>Item</th>
                <th>Unit Price (₦)</th>
                <th>Qty</th>
                {/* <th>Discount (%)</th>
                <th>Discount</th> */}
                {/* <th>
                  VAT
                </th>
                <th>
                  WHT
                </th> */}
                <th>Total Price</th>
                <th>
                  <button type="button" className={classes.addRowBtn} onClick={handleAddRow}>
                    +
                  </button>
                </th>
              </tr>
            </thead>

            <tbody>
              {invoiceItems.map((item, idx) => (
                <tr key={idx}>
                  <td className={classes.productCell}>
                    <div className={classes.customSelect}>
                      <input
                        type="text"
                        className={classes.itemSelectInput}
                        value={item.search || ""}
                        onChange={(e) =>
                          handleChange(idx, "search", e.target.value) // store per-row search
                        }
                        onClick={() => {
                          if (!(isSuperAdmin && !selectedStoreId)) {
                            handleChange(idx, "dropdownOpen", !item.dropdownOpen);
                          }
                        }}
                        placeholder={isSuperAdmin && !selectedStoreId ? "Select a store first" : "Select Item"}
                        disabled={isSuperAdmin && !selectedStoreId}
                      />
                      {item.dropdownOpen && !(isSuperAdmin && !selectedStoreId) && (
                        <div className={classes.dropdownList}>
                          {stocks.filter(stock =>
                            (item.search || "").length > 0
                              ? stock.name.toLowerCase().includes(item.search.toLowerCase())
                              : true
                          ).length > 0 ? (
                            stocks
                              .filter(stock =>
                                (item.search || "").length > 0
                                  ? stock.name.toLowerCase().includes(item.search.toLowerCase())
                                  : true
                              )
                              .map(stock => (
                                <div
                                  key={stock.id}
                                  className={classes.dropdownItem}
                                  onClick={() => {
                                    handleChange(idx, "ledger", stock.name);
                                    handleChange(idx, "search", stock.name); // show name in input
                                    handleChange(idx, "dropdownOpen", false);
                                  }}
                                >
                                  {stock.name}
                                </div>
                              ))
                          ) : (
                            <div className={classes.dropdownItem}>No results found</div>
                          )}
                        </div>
                      )}
                    </div>
                  </td>



                  <td>
                    <input
                      type="text"
                      value={item.price || ""}
                      readOnly
                      className={classes.priceInput}
                    />
                  </td>

                  <td>
                    <input
                      type="number"
                      value={item.qty}
                      onChange={(e) => handleChange(idx, 'qty', e.target.value)}
                      className={classes.qtyInput}
                    />
                  </td>

                  {/* Discount (%) */}
                  {/* <td>
                    <input
                      type="number"
                      value={item.discountRate || ""}
                      onChange={(e) => handleChange(idx, 'discountRate', e.target.value)}
                      className={classes.discountRateInput}
                    />
                  </td>

                
                  <td>
                    <input
                      type="number"
                      value={item.discount}
                      onChange={(e) => handleChange(idx, 'discount', e.target.value)}
                      className={classes.discountInput}
                    />
                  </td> */}

                  {/* VAT (checkbox) */}
                  {/* <td>
                    <input
                      type="checkbox"
                      checked={item.vatChecked || false}
                      onChange={(e) => handleChange(idx, 'vatChecked', e.target.checked)}
                    />
                  </td>

                 
                  <td>
                    <input
                      type="checkbox"
                      checked={item.wthChecked || false}
                      onChange={(e) => handleChange(idx, 'wthChecked', e.target.checked)}
                    />
                  </td> */}

                  {/* Total Price */}
                  <td>
                    <input
                      type="text"
                      value={Number(item.total).toLocaleString(undefined, { minimumFractionDigits: 2 })}
                      readOnly
                      className={classes.totalInput}
                    />
                  </td>


                  <td>
                    <Trash2 style={{width: '-448px'}} size={16} onClick={() => handleDeleteRow(idx)} className={classes.deleteIcon} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>


          <div className={classes.paginationContainer}>
            <div className={classes.paginationControls}>
              <button>First</button>
              <button className={classes.active}>1</button>
              <button>2</button>
              <button>Last</button>
              <span className={classes.pageText}>Displaying 1 - {invoiceItems.length} of {invoiceItems.length}</span>
            </div>
          </div>

          <div className={classes.foot}>
            <div className={classes.Footer}>
              <div className={`${classes.footerSection} ${classes.comments}`}>
                <label>Message</label>
                <textarea className={classes.commentsBox}></textarea>
              </div>
              <div className={`${classes.footerSection} ${classes.summary}`}>
                {/* <div className={classes.grouppp}>
                  <label>Total V.A.T:</label>
                  <input
                    type="text"
                    value={totalVat.toLocaleString(undefined, { minimumFractionDigits: 2 })}
                    readOnly
                    className={classes.summaryInput}
                  />
                </div>
                <div className={classes.grouppp}>
                  <label>Total W.H.T:</label>
                  <input
                    type="text"
                    value={totalWht.toLocaleString(undefined, { minimumFractionDigits: 2 })}
                    readOnly
                    className={classes.summaryInput}
                  />
                </div>


                <div className={classes.grouppp}>
                  <label>Total Discount:</label>
                  <input
                    type="text"
                    value={totalDiscount.toLocaleString(undefined, { minimumFractionDigits: 2 })}
                    readOnly
                    className={classes.summaryInput}
                  />
                </div> */}

                <div className={classes.grouppp}>
                  <label>Total Amount:</label>
                  <input
                    type="text"
                    value={totalAmount.toLocaleString(undefined, { minimumFractionDigits: 2 })}
                    readOnly
                    className={classes.summaryInput}
                  />
                </div>


                <div className={classes.actionButtons}>
                  <button className={classes.cancelButton}>Cancel</button>
                  <button
                    className={classes.saveButton}
                    type="button"
                    onClick={handleSaveInvoice}
                    disabled={isSaving}
                  >
                    {isSaving ? (
                      <>
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                          className="me-2"
                        />
                        Creating...
                      </>
                    ) : (
                      "Create Purchase Order"
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>

        </div>


      </div>
      <Footer />
    </div>

  );
};

export default Prchasing;